import React from "react";

const FormatTimestamp = ({ timestamp, time = false }) => {
  // Check if timestamp is valid
  if (!timestamp) return <span>Not Available</span>;

  const dateObject = new Date(timestamp);

  // Format options
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(time && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // change to false if you want 24hr format
    }),
  };

  const formatted = dateObject.toLocaleString("en-GB", options);

  return <span>{formatted}</span>;
};

export default FormatTimestamp;
